import { useState } from "react";
import { Volume2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { unlockAudio } from "@/lib/push";
import { VOLUMES, isOrderSound, orderVolume, playOrder, setOrderSound, setOrderVolume } from "@/lib/orderSound";

const play = () => { unlockAudio(); playOrder("pedido"); };

export function OrderSoundBox() {
  const [on, setOn] = useState(isOrderSound);
  const [vol, setVol] = useState(orderVolume);
  const toggle = (v) => { setOn(v); setOrderSound(v); };
  const changeVol = (v) => { setVol(v); setOrderVolume(v); play(); };
  return (
    <div className="card-surface p-5 space-y-3" data-testid="order-sound-box">
      <label className="flex items-center justify-between gap-3">
        <span><span className="font-display text-lg font-semibold">Som dos pedidos neste computador</span>
          <span className="block text-sm text-muted-foreground">Pedidos novos do cardápio digital e do delivery tocam a cada 10 segundos até alguém aceitar ou recusar. Pedidos dos garçons e pedidos aceitos automaticamente tocam uma vez. Funciona com o sistema minimizado ou em outra aba.</span></span>
        <Switch checked={on} onCheckedChange={toggle} data-testid="order-sound-switch" />
      </label>
      {on && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium">Volume</span>
          {VOLUMES.map(([v, l, id]) => <Button key={v} size="sm" variant={vol === v ? "default" : "outline"} onClick={() => changeVol(v)} data-testid={`order-sound-volume-${id}`}>{l}</Button>)}
          <Button size="sm" variant="outline" onClick={play} data-testid="order-sound-test-btn"><Volume2 className="h-4 w-4 mr-1" />Tocar teste</Button>
        </div>
      )}
      <p className="text-xs text-muted-foreground">O navegador só libera o som depois de um clique na página: ao abrir o sistema, clique em qualquer lugar uma vez. Deixe o som do Windows ligado. Os outros computadores escolhem o som deles aqui ou no botão de som da tela Delivery.</p>
    </div>
  );
}
